import React, { Component } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TextField from '../../../common/TextField'
import { withStyles } from '@mui/styles'
import Button from '../../../common/Button'
import Grid from '@mui/material/Grid'
import { FormHelperText, InputAdornment } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dense: {
    marginTop: 19
  },
  menu: {
    width: 200
  },
  button: {
    margin: theme.spacing(1)
  }
})

class changedPasword extends Component {
  constructor () {
    super()
    this.state = {
      nPawsErrorMgs: false,
      showPassword: false,
      showConfirmPassword: false,
      form: {
        newPassword: '',
        reapetNewPassword: ''
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.formSubmit = this.formSubmit.bind(this)
    this.formReset = this.formReset.bind(this)
    this.checkRequiredFields = this.checkRequiredFields.bind(this)
  }

  handleTogglePassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  handleToggleConfirmPassword = () => {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword })
  }
  formReset () {
    this.setState({
      nPawsErrorMgs: false,
      form: {
        newPassword: '',
        reapetNewPassword: ''
      }
    })
  }
  formSubmit () {
    const { selectItemId } = this.props
    let { newPassword, reapetNewPassword } = this.state.form
    if (newPassword.trim().length > 0 && reapetNewPassword.trim().length > 0) {
      if (newPassword === reapetNewPassword) {
        this.setState({
          nPawsErrorMgs: false
        })
      } else {
        this.setState({
          nPawsErrorMgs: true
        })
      }
    } else {
      this.setState({
        nPawsErrorMgs: true
      })
    }
    if (
      newPassword.trim().length > 0 &&
      reapetNewPassword.trim().length > 0 &&
      newPassword === reapetNewPassword
    ) {
      fetch(`api/users/${this.props.logInUser.id}/resetpassword`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': ' application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(
          `entityId=${selectItemId.id}&npass=${this.state.form.newPassword}`
        )
      })
        .then(response => {
          if (response.ok) {
            response.json().then(res => {
            if(res.status ==='success'){  
                  toast.success(
                  this.props.translate('passwordIsChanged'),
                  )
                this.setState({
                  form: {
                    newPassword: '',
                    reapetNewPassword: ''
                  },
                  nPawsErrorMgs: false
                })
              }
              else if(res?.statusCode === '440'){
                window.location.replace('/login')
              }
              else if(res.statusCode){
                var err = res?.message.split(':')
                err[1] =err[1].replace(')', "")
                  toast.error(this.props.translate(err[1]))
              }
            })
          } 
          else {
            throw response
          }
        })
        .catch(e => {
         
            toast.error( this.props.translate('somethingWentWrong')
             )
        })
    } else {
     
        toast.error(this.props.translate('emptyField'),
        )
    }
  }

  handleChange = name => event => {
    const { target } = event

    this.setState(
      {
        form: {
          ...this.state.form,
          [name]: target.value
        }
      },
      () => this.checkRequiredFields()
    )
  }

  checkRequiredFields () {
    let { newPassword, reapetNewPassword } = this.state.form
    if (newPassword.trim().length > 0 && reapetNewPassword.trim().length > 0) {
      if (newPassword === reapetNewPassword) {
        this.setState({
          nPawsErrorMgs: false
        })
      } else {
        this.setState({
          nPawsErrorMgs: true
        })
      }
    } else {
      this.setState({
        nPawsErrorMgs: true
      })
    }
  }

  render () {
    return (
      <div>
        <Grid container spacing={4}>
          <Grid item xs={12} md={3} sm={6}>
            <TextField
              id='newPassword'
              label={this.props.translate('newPassword')}
              type={this.state.showPassword ? 'text' : 'password'}
              placeholder=''
              error={this.state.nPawsErrorMgs}
              value={this.state.form.newPassword || ''}
              onChange={this.handleChange('newPassword')}
              variant='outlined'
              margin='dense'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <div
                      style={{ cursor: 'pointer', marginTop: '3px', display: 'flex' }}
                      onClick={this.handleTogglePassword}
                    >
                      {this.state.showPassword ? (
                        <VisibilityOffOutlinedIcon
                          style={{ color: this.props.themecolors?.menuActiveBackground }}
                        />
                      ) : (
                        <VisibilityOutlinedIcon
                          style={{ color: this.props.themecolors?.menuActiveBackground }}
                        />
                      )}
                    </div>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={3} sm={6}>
            <TextField
              id='reapetNewPassword'
              error={this.state.nPawsErrorMgs}
              label={this.props.translate('reNewPassword')}
              type={this.state.showConfirmPassword ? 'text' : 'password'}
              placeholder=''
              value={this.state.form.reapetNewPassword || ''}
              onChange={this.handleChange('reapetNewPassword')}
              variant='outlined'
              margin='dense'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <div
                      style={{ cursor: 'pointer', marginTop: '3px', display: 'flex' }}
                      onClick={this.handleToggleConfirmPassword}
                    >
                      {this.state.showConfirmPassword ? (
                        <VisibilityOffOutlinedIcon
                          style={{ color: this.props.themecolors?.menuActiveBackground }}
                        />
                      ) : (
                        <VisibilityOutlinedIcon
                          style={{ color: this.props.themecolors?.menuActiveBackground }}
                        />
                      )}
                    </div>
                  </InputAdornment>
                ),
              }}
            />
            <FormHelperText 
                      style={{ fontWeight: "bold", color :  "red" , 
                        // fontSize:"12px"
                      }} // Changed fontWeight and color
                      error={this.state.nPawsErrorMgs ? true : false}
                      >
                      {this.props.translate(`passwordMustbeSame`)}
                    </FormHelperText>
          </Grid>
        </Grid>

        <br />
        <Button variant='contained' onClick={() => this.formReset()}>
          {' '}
          {this.props.translate('resetButton')}
        </Button>
        <Button
          variant='contained'
          style={{ marginLeft: 8 }}
          // disabled={!this.state.isVisableBtn}
          onClick={() => this.formSubmit()}
        >
          {this.props.translate('changePassword')}
        </Button>
      </div>
    )
  }
}
const ChangedPasword = withStyles(styles)
export default ChangedPasword(changedPasword)
